<template>
  <div class="comparison">
    <Top @showHowto="handleOpenModal()" />
    <!-- <steps :step="3" /> -->
    <Contents :items="items" />
    <BackButton
      class="back-button"
      :class="{ isHidden: isHiddenBackButton }"
      @clickButton="$router.push('/')"
    >
    </BackButton>
    <transition name="fade">
      <HowToModal v-if="isShownModal" @close="handleCloseModal()"></HowToModal>
    </transition>
  </div>
</template>
<script>
import {
  enableBodyScroll,
  disableBodyScroll,
  clearAllBodyScrollLocks,
} from "body-scroll-lock";
import { mapGetters } from "vuex";
import Top from "../model/comparison/Top.vue";
import Contents from "../model/comparison/Contents.vue";
import HowToModal from "../model/comparison/HowToModal.vue";
import BackButton from "../model/common/BackButton.vue";
import { TODAY_KEY } from "../../config/DATE_KEY";
// import Steps from '../model/common/Steps.vue';

export default {
  name: "Comparison",
  components: {
    Top,
    Contents,
    HowToModal,
    BackButton,
    // Steps,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isShownModal: false,
      timeoutId: null,
    };
  },
  computed: {
    ...mapGetters(["scrollDirection"]),
    isHiddenBackButton() {
      return this.scrollDirection === "scroll-down";
    },
  },
  methods: {
    handleCloseModal() {
      this.isShownModal = false;
    },
    handleOpenModal() {
      this.isShownModal = true;
    },
    init() {
      localStorage.setItem(TODAY_KEY, "1");
      this.timeoutId = setTimeout(() => this.handleOpenModal(), 1000);
    },
  },
  mounted() {
    const hasAccessed = localStorage.getItem(TODAY_KEY);
    if (!hasAccessed) {
      this.$nextTick(() => {
        this.init();
      });
    }
  },
  beforeDestroy() {
    clearAllBodyScrollLocks();
  },
  destroyed() {
    if (this.timeoutId) clearTimeout(this.timeoutId);
  },
  watch: {
    isShownModal(isShown) {
      isShown ? disableBodyScroll() : enableBodyScroll();
    },
  },
};
</script>
<style lang="scss" scoped>
.comparison {
  padding: 40px 0;
  position: relative;

  .back-button {
    position: sticky;
    left: 20px;
    bottom: 20px;
    z-index: 2;
    transition: transform 0.4s 0.4s $easing-bounce,
      opacity 0.3s 0.4s $easing-opacity;
    opacity: 1;

    &.isHidden {
      pointer-events: none;
      opacity: 0;
      transform: translateY(10px);
    }
  }

  @include media() {
    padding: vw(16) 0 vw(30);

    .back {
      left: vw(15);
      bottom: vw(15);
    }

    .back-button {
      left: vw(15);
      bottom: vw(15);

      &.isHidden {
        transform: translateY(vw(10));
      }
    }
  }
}
</style>
